<template>
    <zone
        auto-height
        align="center"
        class="dispenser"
        contrast="light"
        :data-label="dico.dataLabel"
        :id="dico.id"
        v-if="isDisplayed"
    >
        <heading :level="2" v-html="dico.title" />
        <paragraph :size="sizes.text" :content="dico.text" />
        <div class="variants">
            <dispenser-variant
                :variant="variant"
                :key="variant.title"
                v-for="variant in dico.variants"
            />
        </div>
    </zone>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Zone from 'gvue/src/core/Zone'
import DispenserVariant from '@/components/dispenser/DispenserVariant'

export default {
    name: 'SectionDispenser',
    components: {
        Heading,
        Paragraph,
        Zone,
        DispenserVariant
    },
    created () {
        this.dico = this.$json.dispenser
    },
    computed: {
        sizes () {
            return { text: this.$breakpoint.isS ? 'L' : 'XL' }
        },
        isDisplayed () {
            return this.dico.display
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.dispenser
    background-color: $color_background

+desktop
    .variants
        display: flex
        justify-content: center

        > *
            flex-basis: 33.333%

            + *
                margin-left: ($gap * 5)

@media screen and (min-width: 768px) and (max-width: 1200px)
    .variants
        flex-wrap: wrap
</style>
